/**
 * 
 *  created by AHMED HAYEL 
 *
 */

export class CompteServer {

    idCompteClientServer: number;
    pseudo: string;
    intervaleStart: number;
    intervaleEnd: number;
    ipAdresse: string;
    login: string;
    date_creation: number;
    date_Expiration: number;
    password: string;
    expired: boolean;
    during: boolean;
    
    str_expiration: string;
    constructor() {
        this.idCompteClientServer = 0;

        this.pseudo = "";
        this.ipAdresse = "";

        this.login = "";

        this.password = "";
        this.expired = false;

        this.during = false;
        this.intervaleStart = 0;
        this.intervaleEnd = 0;
        this.str_expiration = "";
    }
}


// WEBPACK FOOTER //
// ./src/app/Model/CompteServer.ts